<div id="denied-container" class="container">
    <app-headline [headline]="'ACCESS_DENIED_TITLE' | translate"></app-headline>
    <p>{{ 'ACCESS_DENIED_TEXT' | translate }}</p>
</div>